// PyramidChart.js
import React from "react";

const statusStyles = {
  Severe: {
    backgroundColor: "#E7000B",
    borderColor: "rgba(0, 0, 0, 0.10)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
  },
  Moderate: {
    backgroundColor: "#FD9A00",
    borderColor: "rgba(0, 0, 0, 0.10)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
  },
  Minor: {
    backgroundColor: "#FEE685",
    borderColor: "rgba(0, 0, 0, 0.10)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
  },
};

const KeyPyramidChart = ({ data }) => {
  return (
    <>
      <div className="mt-8 flex flex-col items-center">
        {data.map((item, index) => {
          const { backgroundColor, borderColor, boxShadow } = statusStyles[item.status];
          return (
            <div
              key={index}
              className={`${
                item.value === 0 ? "text-white" : "text-[#0A0A0A]"
              } flex justify-between items-center px-4 py-1 font-medium text-sm w-full`}
              style={{
                backgroundColor,
                border: `1px solid ${borderColor}`,
                boxShadow,
                width: `${60 + index * 5}%`,
                maxWidth: "100%",
                minHeight: "40px",
                borderRadius: "4px",
              }}
            >
              <span>{item.label}</span>
              <span>{item.value}</span>
            </div>
          );
        })}
      </div>

      {/* Legends */}
      <div className="mt-6 flex justify-center gap-6 text-sm">
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 rounded-full" style={{ backgroundColor: "#E7000B" }}></span>
          <span className="text-[#0A0A0A]">Severe</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 rounded-full" style={{ backgroundColor: "#FD9A00" }}></span>
          <span className="text-[#0A0A0A]">Moderate</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-4 h-4 rounded-full" style={{ backgroundColor: "#FEE685" }}></span>
          <span className="text-[#0A0A0A]">Minor</span>
        </div>
      </div>
    </>
  );
};

export default KeyPyramidChart;
